import * as React from 'react';
import { SVGProps } from 'react';

const IconDropSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 15.364C2 9.636 9.5 2 9.5 2s2.253 2.294 4.29 5.31l-.079.176c-.447 1.023-.71 1.99-.71 2.828 0 2.386 1.625 4.403 3.988 4.659.007.13.011.261.011.39C17 19.758 13.642 23 9.5 23 5.358 23 2 19.757 2 15.364z" />
    <path d="M15.543 8.288c-.391.894-.543 1.574-.543 2.026C15 11.88 16.081 13 17.5 13s2.5-1.12 2.5-2.686c0-.452-.152-1.132-.543-2.026-.38-.865-.91-1.765-1.479-2.607A25.49 25.49 0 0 0 17.5 5a25.49 25.49 0 0 0-.478.681c-.57.842-1.1 1.742-1.479 2.607z" />
  </svg>
);
export default IconDropSizeM;
